import { Link } from "react-router-dom";

const variants = {
  primary: "bg-primary text-white hover:bg-secondary shadow-soft",
  secondary: "bg-white text-dark border border-line hover:border-primary hover:text-primary",
  ghost: "bg-transparent text-dark hover:bg-emerald-50 hover:text-primary",
  dark: "bg-dark text-white hover:bg-slate-700",
};

export default function Button({ children, to, type = "button", variant = "primary", className = "", ...props }) {
  const disabledClasses = props.disabled ? "cursor-not-allowed opacity-60 hover:bg-slate-200 hover:text-slate-500" : "";
  const classes = `inline-flex min-h-11 items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-bold transition duration-200 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${variants[variant]} ${disabledClasses} ${className}`;
  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }
  return (
    <button type={type} className={classes} {...props}>
      {children}
    </button>
  );
}
